/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1TutoraiConfigPersona200,
  GetApiV1TutoraiConfigPersona401,
  GetApiV1TutoraiConfigPersona500,
  GetApiV1TutoraiConfigPersonaQueryParams,
  GetApiV1TutoraiConfigPersonaQueryResponse,
} from "../../types/tutorAIConfigController/GetApiV1TutoraiConfigPersona.ts";
import { tutorAIPromptConfigViewModelSchema } from "../tutorAIPromptConfigViewModelSchema.ts";

export const getApiV1TutoraiConfigPersonaQueryParamsSchema = z
  .object({
    classStudentId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1TutoraiConfigPersonaQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1TutoraiConfigPersona200Schema = z.lazy(
  () => tutorAIPromptConfigViewModelSchema,
) as unknown as ToZod<GetApiV1TutoraiConfigPersona200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1TutoraiConfigPersona401Schema =
  z.any() as unknown as ToZod<GetApiV1TutoraiConfigPersona401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1TutoraiConfigPersona500Schema =
  z.any() as unknown as ToZod<GetApiV1TutoraiConfigPersona500>;

export const getApiV1TutoraiConfigPersonaQueryResponseSchema = z.lazy(
  () => getApiV1TutoraiConfigPersona200Schema,
) as unknown as ToZod<GetApiV1TutoraiConfigPersonaQueryResponse>;
